<template>
  <section
    class="component-b76df896"
    resmed-component-name="recommended_50/50_mask_name_type_video_2cta"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="items">
          <div class="row item" v-for="item in masks">
            <div class="col-md-6 col-xl-5">
              <div class="embed-responsive embed-responsive-997by720">
                <iframe
                  class="embed-responsive-item"
                  v-bind:src="`//players.brightcove.net/2750693505001/${item.player_id}_default/index.html?videoId=${item.video_id}`"
                  allowfullscreen
                  webkitallowfullscreen
                  mozallowfullscreen
                  allow="encrypted-media"
                  style="
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    bottom: 0px;
                    left: 0px;
                    width: 100%;
                    height: 100%;
                  "
                ></iframe>
              </div>
            </div>
            <div class="col-md-6 col-xl-6">
              <div class="mt-4 mt-md-0 ml-md-4">
                <h2>{{ item.model }}</h2>
                <div class="mask-style">
                  <span class="mask-type">{{ item.type }}</span>
                  <span class="mx-2">|</span>
                  <span class="mask-catgory">{{ item.category }}</span>
                </div>
                <div class="reason-for-recommendation">
                  <p>Recommended for you because:</p>
                  <h3>{{ item.recommendation[0].reason }}</h3>
                  <template v-if="item.recommendation[1]">
                    <span>AND / OR</span>
                    <h3>{{ item.recommendation[1].reason }}</h3>
                  </template>
                </div>
                <div class="call-to-action">
                  <a
                    v-bind:href="item.cta[0].href"
                    target="_blank"
                    class="btn cta-pill filled-red icon right-arrow mr-3"
                    >{{ item.cta[0].text }}</a
                  >
                  <a
                    v-bind:href="item.cta[1].href"
                    target="_blank"
                    class="btn cta-pill hallow-white icon right-arrow"
                    >{{ item.cta[1].text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-b76df896", // recommended_50/50_mask_name_type_video_2cta
  props: ["acf"],
  data() {
    return {
      masks: [],
    };
  },
  created() {
    // only display the recommended masks based on the quiz results
    let recommended = JSON.parse(
      localStorage.getItem("mask-selector-quiz-results")
    );

    if (!recommended) {
      window.location.href = "/sleep-apnea/best-cpap-mask-for-me/";
    }

    this.masks = recommended.data;
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b76df896 {
  background-color: $cc-resmed-sa-purple;
  background-image: url(#{$assets}/images/sleep-apnea--mask-selector--results-purple-spots-bkg.png);
  background-size: 1300px;
  background-position: center calc(100% + 20rem);
  background-repeat: no-repeat;
}

.component {
  padding-bottom: 8rem;

  @media (min-width: 992px) {
    padding-bottom: 9rem;
  }

  @media (min-width: 1200px) {
    padding-bottom: 14rem;
  }

  .item {
    padding: 4rem 0;
    border-bottom: 1px solid rgba($cc-resmed-white, 0.325);
    color: $cc-resmed-white;

    @media (min-width: 768px) {
      padding: 6rem 0;
    }

    h2,
    h3 {
      margin-bottom: 0;
    }

    h3 {
      @media (min-width: 768px) {
        font-size: 1.25rem;
      }
    }

    @media (min-width: 768px) {
      &:nth-child(2) {
        > div:first-child {
          order: 1;
        }
      }
    }

    .mask-style {
      margin: 0.125rem 0 2rem 0;
      @extend %body-small-bold;
    }

    .reason-for-recommendation {
      margin-bottom: 3rem;

      > span {
        display: block;
        margin: 0.875rem 0;
        @extend %body-x-small;
      }

      h3 {
        padding-left: 1.5rem;
        background-image: url(#{$assets}/images/form-checkbox-true-white.svg);
        background-position: left 4px;
        background-repeat: no-repeat;
        background-size: 1rem;
      }
    }

    .call-to-action {
      a:first-child {
        @media (max-width: 364px) {
          margin-bottom: 1rem;
        }
      }
    }

    .embed-responsive {
      border-radius: 8px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 0, 0, 0.3);
    }
  }
}
</style>